// extracted by mini-css-extract-plugin
export default {"swiperWrapper":"TasksList_swiperWrapper__14YLU"};